/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Save_Failed1Inputs */

const vi_cmspost_save_failed1 = /** @type {(inputs: Cmspost_Save_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được bài viết. Kiểm tra mạng rồi thử lại.`)
};

/**

* @param {Cmspost_Save_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_save_failed1 = /** @type {((inputs?: Cmspost_Save_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Save_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_save_failed1(inputs)
});
export { cmspost_save_failed1 as "cmsPost_save_failed" }